import React from 'react'

function App() {
 return (
 <div className="App">
 <h1>欢迎使用 Nexus智能工作平台</h1>
 <p>页面正在建设中...</p>
 </div>
 )
}

export default App
